export default "<h1>Type1String list</h1>\n<spec-app-type1-string-table [clickHandler]=\"createClickHandler()\"></spec-app-type1-string-table>";